import axios from "../axios1";

// 获取所有教育局列表
export const getAllEdu = (data) => {
  return axios({
    url: "/console/education/list",
    method: "GET",
    data: data,
  });
};
// 获取学校列表
export const getAllSchool = (data) => {
  return axios({
    url: "/console/school/list_by_education",
    method: "GET",
    data: data,
  });
};
// 获取年级列表
export const getAllGrade = (data) => {
  return axios({
    url: "/console/homework_class/list_by_school_and_group",
    method: "GET",
    data: data,
  });
};
// 获取作业列表
export const getAllJobs = (data) => {
  return axios({
    url: "/console/ch/getHomeworkCalendar",
    method: "GET",
    data: data,
  });
};
// 作业公示详情
export const getJobDetail = (data) => {
  return axios({
    url: "/console/ch/getClassHomeworks",
    method: "GET",
    data: data,
  });
};

export const getClassWorkList = (data) => {
  return axios({
    url: "/console/ch/getHomeworkCalendar",
    method: "GET",
    data: data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/noCheckApi.js